export default __webpack_public_path__ + "static/media/img-0313-madagascar-full-face.ea4e35e6.png";